import React, { useEffect, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import { getNotificationsHistory } from "./api";
import styleConstants from "../../constants/styleConstants";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import Layout from "../../components/layout";
import EmptyOrShow from "../../components/EmptyOrShow";
import ExpandableText from "../../components/UI/ExpandableText";
import { unicodeEscapesToEmoji } from "../../utils/emojis";

const CustomTooltip = withStyles(() => ({
  tooltip: {
    fontSize: 11,
    backgroundColor: "#383838",
    padding: "5px 10px",
  },
}))(Tooltip);

const NotificationsHistory = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getNotificationsHistory()
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const renderHtmlText = (text) => {
    if (!text) return null;
    const processedText = unicodeEscapesToEmoji(text);
    const withBr = processedText.replace(/\r\n|\r|\n/g, "<br/>");
    return <span dangerouslySetInnerHTML={{ __html: withBr }} />;
  };

  return (
    <Layout title="Уведомления">
      <Box sx={{ padding: "65px 20px 20px" }}>
        <Box className={classes.table_wrapper}>
          <EmptyOrShow loading={loading}>
            <TableContainer className={classes.table_container}>
              <Table size="small" aria-label="table">
                <TableHead className={classes.table_head}>
                  <TableRow>
                    {headTitle.map((el) => {
                      return <TableCell key={el}>{el}</TableCell>;
                    })}
                  </TableRow>
                </TableHead>
                <TableBody className={classes.table_body}>
                  {data.map((e) => {
                    return (
                      <TableRow key={e.notice_id}>
                        <TableCell align="left">
                          <b>{renderHtmlText(e.head_text)  || ""}</b> <br />{" "}
                          <ExpandableText
                            text={e.body_text || ""}
                            renderHtml={renderHtmlText}
                          />
                        </TableCell>
                        <TableCell align="left">
                          {e.is_check ? (
                            <CheckIcon className={`${classes.green}`} />
                          ) : (
                            <CloseIcon className={`${classes.red}`} />
                          )}  
                        </TableCell>
                        <TableCell align="left">{e.date_check}</TableCell>
                        <TableCell align="left">{e.date_create}</TableCell>
                        <TableCell align="left">{e.creater}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </EmptyOrShow>
        </Box>
      </Box>
    </Layout>
  );
};

export default NotificationsHistory;
const headTitle = [
  "Текст уведомления",
  "Ознакомлен",
  "Дата ознакомления",
  "Дата уведомления",
  "Создатель уведомления",
];
const useStyles = makeStyles({
  table_wrapper: {},
  table_container: {
    border: "1px solid #f0f2f6",
    background: "white",
    "&::-webkit-scrollbar": {
      width: 8,
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: styleConstants.primaryColor,
      borderRadius: styleConstants.borderRadius,
    },
  },
  table_head: {
    background: "white",
    "& th": {
      fontSize: "12px",
      fontWeight: 600,
      background: "white",
    },
    "& th:first-child": {
      maxWidth: "800px",
      width: "800px",
    },
  },
  table_body: {
    "& tr": {
      transition: "0.4s",
      "&:hover": {
        background: "#d3d3d36e",
      },
    },
    "& td:first-child": {
      maxWidth: "800px",
      width: "800px",
      wordWrap: "break-word",
    },
  },
  green: {
    color: "#4CAF50",
  },
  red: {
    color: "#FF6262",
  },
});
